import "../Css/Notifications.css";
import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import NoticeNotification from "./NoticeNotification";
import { ListenToEventSource, askNotificationPermission } from "../store/api/CommonFunctions";
import { Button } from "react-bootstrap";

let notificationArchive = [];
const NotificationArea = () => {

    const history = useHistory();
    let [notifCount, setNotifications] = useState(notificationArchive.length);
    const noticeNotifications = notificationArchive ? notificationArchive.sort((a, b) => b.ID - a.ID).filter(n => n.Type.includes("Notice")) : [];

    const onGetNotify = (notif) => {
        const notifJson = JSON.parse(notif);
        notificationArchive.push(notifJson);
        setNotifications(notificationArchive.length);
        if ('Notification' in window) {
            if (notifJson.Type.includes("Notice")) {
                const n = new Notification('اطلاعیه جدید',
                    {
                        body: "موضوع : " + notifJson.NoticeSubject,
                        icon: "../content/images/circle.png"
                    });
            }
            else if (notifJson.Type.includes("NewTicket")) {
                const title = notifJson.Type === "NewTicket"?"تیکت جدید":"پاسخ به تیکت";
                const n = new Notification(title,
                    {
                        body: "شناسه تیکت: " + notifJson.TicketID + "\n" + "نام مشتری: " + notifJson.CustomerName,
                        icon: "../content/images/circle.png"
                    });
            }
        }
    }
    useEffect(() => {
        askNotificationPermission();
        ListenToEventSource(onGetNotify);
    }, []);
    const removeNotification = (id) => {
        notificationArchive = notificationArchive.filter(n => n.ID !== id);
        setNotifications(notificationArchive.length);
    }
    function clearAll() {
        notificationArchive = [];
        setNotifications(0);
    }
    const openProfile = (id, type) => {
        history.push(getDestUrl(id, type));
    }
    function getDestUrl(id, type) {
        let url = "";
        if (type === "Notice" ) {
            url = "/NoticeBoard";
        }
        return url;
    }
    return (


        <div className="notificationArea">
            <input type="hidden" readOnly value={notifCount} />
            {noticeNotifications && Array.isArray(noticeNotifications) &&
                noticeNotifications.map((notif, i) =>
                    <NoticeNotification notif={notif} key={i} remove={removeNotification} openProfile={openProfile} getDestUrl={getDestUrl} />)
            }
            {notifCount > 0 &&
                <div>
                    <Button variant="info" className="group-Btn-smalll" onClick={clearAll}>پاک کردن همه</Button>
                </div>
            }
        </div>
    )
}
export default NotificationArea;